import { DateTime } from 'luxon';

// https://www.irt.org/articles/js052/index.htm
export const getEasterDay = (year: number) => {
    const C = Math.floor(year / 100);
    const N = year - 19 * Math.floor(year / 19);
    const K = Math.floor((C - 17) / 25);
    let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor(I / 30);
    I =
        I -
        Math.floor(I / 28) *
            (1 -
                Math.floor(I / 28) *
                    Math.floor(29 / (I + 1)) *
                    Math.floor((21 - N) / 11));
    let J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    const L = I - J;
    const month = 3 + Math.floor((L + 40) / 44);
    const day = L + 28 - 31 * Math.floor(month / 4);

    return DateTime.fromObject({ year, month, day });
};

const isNewYearsEve = (dt: DateTime) => dt.month === 12 && dt.day === 31;
const isNewYearsDay = (dt: DateTime) => dt.month === 1 && dt.day === 1;
const isCarnivalPeriod = (dt: DateTime) => {
    const easter = getEasterDay(dt.year);
    const carnival = easter.minus({ days: 47 });
    return (
        dt.month === carnival.month &&
        (dt.day === carnival.day ||
            dt.day === carnival.day - 1 ||
            dt.day === carnival.day + 1)
    );
};
const isPassionOfChristDay = (dt: DateTime) => {
    const easter = getEasterDay(dt.year);
    return dt.month === easter.month && dt.day === easter.day - 2;
};
const isTiradentesDay = (dt: DateTime) => dt.month === 4 && dt.day === 21;
const isLaborDay = (dt: DateTime) => dt.month === 5 && dt.day === 1;
const isCorpusChristiDay = (dt: DateTime) => {
    const easter = getEasterDay(dt.year);
    const corpusChristi = easter.plus({ days: 60 });
    return dt.month === corpusChristi.month && dt.day === corpusChristi.day;
};
const isIndependenceDay = (dt: DateTime) => dt.month === 9 && dt.day === 7;
const isChildrensDay = (dt: DateTime) => dt.month === 10 && dt.day === 12;
const isAllSoulsDay = (dt: DateTime) => dt.month === 11 && dt.day === 2;
const isProclamationDay = (dt: DateTime) => dt.month === 11 && dt.day === 15;
const isBlackAwarenessDay = (dt: DateTime) => dt.month === 11 && dt.day === 20;
const isChristmasDay = (dt: DateTime) => dt.month === 12 && dt.day === 25;

const bankHolidayMatchers = [
    isNewYearsEve,
    isNewYearsDay,
    isCarnivalPeriod,
    isPassionOfChristDay,
    isTiradentesDay,
    isLaborDay,
    isCorpusChristiDay,
    isIndependenceDay,
    isChildrensDay,
    isAllSoulsDay,
    isProclamationDay,
    isBlackAwarenessDay,
    isChristmasDay,
];

export const isBankHoliday = (dt: DateTime) =>
    bankHolidayMatchers.some(matchFn => matchFn(dt));
